// react
import React, { useImperativeHandle, forwardRef } from 'react'

// translation + capitalize
import { capitalize } from 'lodash'

// ui
import { Select as SelectComponent } from 'antd'
import * as s from './styles'

const Select = forwardRef((props, ref) => {
  const {
    placeholder,
    list,
    action: { state, setState },
  } = props

  // clear content from parent
  useImperativeHandle(ref, () => {
    return {
      clear() {
        setState([])
      },
    }
  })

  // inside changes

  const handleOnChange = (value) => {
    setState(value)
  }

  return (
    <s.FiltersWrapper>
      <SelectComponent
        showArrow
        allowClear
        value={state}
        mode="multiple"
        size="large"
        placeholder={capitalize(placeholder)}
        onChange={handleOnChange}
        options={list}
        style={{ width: '100%' }}
      />
    </s.FiltersWrapper>
  )
})

export default Select
